const SNIPPETS = [
  { label: "Heading", value: "# Hello World\n" },
  { label: "Bold", value: "**bold text**" },
  { label: "Italic", value: "_italic text_" },
  { label: "Link", value: "[title](https://example.com)" },
  { label: "Code", value: "`inline code`" },
  { label: "Block", value: "```\ncode block\n```" },
  { label: "List", value: "- item one\n- item two\n- item three\n" },
  { label: "Quote", value: "> blockquote\n" },
];

export default SNIPPETS;
